import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, createUrlTreeFromSnapshot } from '@angular/router';
import { QuizFacade } from '../facades/quizes.facade';
import { filter, map, take, tap } from 'rxjs';

export const quizLoaded: CanActivateFn = (route: ActivatedRouteSnapshot) => {
    const quizFacade = inject(QuizFacade);
    const quizId = route.paramMap.get('quizId');

    if (!quizId) {
        return createUrlTreeFromSnapshot(route, ['/dashboard']);
    }

    return quizFacade.loaded$(quizId).pipe(
        tap((loaded) => {
            if (loaded !== true) {
                quizFacade.getQuiz(quizId);
            }
        }),
        filter((loaded) => loaded !== null),
        map((loaded) => {
            if (loaded === false) {
                return createUrlTreeFromSnapshot(route, ['/dashboard']);
            }
            return true;
        }),
        take(1),
    );
};
